import { LoadingScreen } from '@layouts/dashboard/components/LoadingScreen'
import { Outlet } from 'react-router-dom'

const AuthLayout = () => {
    return (
        <>
            <LoadingScreen />
            <Outlet />
        </>
    )
}

export default AuthLayout
